import ILLUMINANTS from '../constants/illuminants'

export default function getIlluminant (ref) {
  return ILLUMINANTS[ref]
}
